import { MilestoneStatusResponses } from './DataRoomUser';
import { StructureTranches, Tier1BankTypes, Tier3ContactTypes } from './TrancheEvaluation';

export interface MilestoneReport {
	id: number;
	guid: string;
	dataRoomId: number;
	dataRoomGuid: string;
	bankId: number;
	bankGuid: string;
	bankContactGuid: string;
	personId: number;
	userId: number;
	userGuid: string;
	bankDealProfileId: number;
	bankDealProfileGuid: string;
	bankName: string;
	firstName: string;
	lastName: string;
	lenderName: string;
	emailAddress: string;
	phone: string;
	activeUser: boolean;
	structureTranche?: StructureTranches;
	tier1Type?: Tier1BankTypes;
	tier3ContactType?: Tier3ContactTypes;
	tier3ContactTypeDescription: string;

	roomDeclineReasons: string;
	roomDeclineReasonList: string[];
	otherRoomDeclineReason: string;
	hasRoomOptOutReasons: boolean;
	roomReasonDetail: string;
	teaser: MilestoneStatusResponses;
	teaserDate: Date | null;
	otherDeclineReason: string;
	lenderDeclineReasons: string;
	teaserDeclineReasonList: string[];
	accessDeal: MilestoneStatusResponses;
	lastAccessedOn: Date | null;
	documentsDownloaded: MilestoneStatusResponses;
	documentsDownloadedDate: Date | null;
	readyForCall: MilestoneStatusResponses;
	readyForCallOn: Date | null;
	dataRoomCallGuid: string | null;
	callStatus: CallStatuses | null;
	callDate: Date | null;
	callTimeZone: string | null;
	callDetails: string | null;
	hasCompletedCalls: boolean;
	termSheetSubmitted: MilestoneStatusResponses;
	termSheetSubmittedOn: Date | null;
	underwriting: MilestoneStatusResponses;
	underwritingOn: Date | null;
	funded: MilestoneStatusResponses;
	dateFunded: Date | null;
	amountFunded: number | null;

	dealBankStatus: string;
	noteCount: number;
	optedOut: boolean;
	isLockedOut: boolean;
	allowAccess?: boolean;
	signedNda: boolean;
}

export type MilestoneTypes = keyof typeof MilestoneTypesMap;
export const MilestoneTypesMap = {
	Teaser: 'Teaser',
	AccessDeal: 'Access Deal',
	DocumentsDownloaded: 'Documents Downloaded',
	ReadyForCall: 'Ready For Call',
	TermSheetSubmitted: 'Term Sheet Submitted',
	Underwriting: 'Underwriting',
	Funded: 'Funded',
};

export type CallStatuses = keyof typeof CallStatusesMap;
export const CallStatusesMap = {
	Proposed: 'Proposed',
	Scheduled: 'Scheduled',
	Completed: 'Completed',
	Cancelled: 'Cancelled',
};
